import React, {useEffect} from "react";
import {Button, Input} from "reactstrap";
import {addDate, formatDate, subtractDate} from "../../script/commFunc";
import {useRef} from "react";

/**
 *
 * @User : 백욱진
 * @Date : 2023.05.04
 * @file : Components/Common/CpmCommYearMon.js
 * @Desc : 데이트 픽커 컴포넌트(yyyy-MM)
 * @param {string} id - id값 (부모 컴포넌트의 파라미터 key 값으로도 사용)
 * @param {object} params - 부모 컴포넌트로부터 받아온 파라미터 객체
 * @param {React.SetStateAction} setParams - 부모 컴포넌트로부터 받아온 파라미터 세터
 * @param {string} label - 라벨 명
 * @param {boolean} essential - 필수 여부
 * @param {string} maxDate - 입력할 수 있는 최대 날짜
 * @param {string} minDate - 입력할 수 있는 최소 날짜
 * @param {boolean} isDisabled - disabled 여부
 */

const CpmCommYearMon = ({
    id, 
    params, 
    setParams,
    label,
    essential = false,
    maxMon,
    minMon,
    isDisabled,
}) => {
    const paramNm = id || 'yearmon'
    const paramsFormat = "yyyyMM";
    const localFormat = "yyyy-MM";
    const maxMonth = maxMon ? formatDate(maxMon, paramsFormat) : '999912';
    const minMonth = minMon ? formatDate(minMon, paramsFormat) : '100001';
    const today = formatDate(new Date(), paramsFormat);
    const yearMonRef = useRef(null); // yearMonRef element에 접근 제어

    // 월 증가
    const handleIncreaseYearMon = (ref) => {
        if (formatDate(ref, paramsFormat) < minMonth) {
            setParams({[paramNm]: minMonth});
        } else if(formatDate(ref, paramsFormat) < maxMonth){
            setParams({[paramNm]: addDate(ref, paramsFormat, "months")});
        }
    };
    // 월 감소
    const handleDecreaseYearMon = (ref) => {
        if (formatDate(ref, paramsFormat) > maxMonth) {
            setParams({[paramNm]: maxMonth});
        } else if (formatDate(ref, paramsFormat) > minMonth){
            setParams({[paramNm]: subtractDate(ref, paramsFormat, "months")});
        }
    };
    // 날짜 변경 감지
    const onChangeYearMon = (e) => {
        setParams({[paramNm]: formatDate(e.target.value, paramsFormat)});
    };

    useEffect(() => {
        // 부모 params 초기값 세팅 
        setParams({[paramNm]: params[paramNm] || today});
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (
        <div className="d-flex  align-items-center">
            <Input
                id={id}
                name={label || paramNm}
                type="month"
                className={`${essential && 'essential'} form-control-sm`}
                style={{width:"120px"}}
                value={formatDate(params[paramNm], localFormat)}
                onChange={onChangeYearMon}
                ref={yearMonRef}
                disabled={isDisabled}
                max={formatDate(maxMonth, localFormat)}
                min={formatDate(minMonth, localFormat)}
            />
            {!isDisabled &&
            <>
                <Button
                    size="sm"
                    className="btn-icon btn-sm btn-soft-dark fs-6 rounded-1"
                    style={{borderColor:"#a9a8a8",height:"22px", width:"22px"  }}
                    onClick={() => handleDecreaseYearMon(yearMonRef.current.props.value)}
                    ><i className="ri-arrow-left-s-line"></i></Button>
                <Button
                    size="sm"
                    className="btn-icon btn-sm btn-soft-dark fs-6 rounded-1"
                    style={{borderColor:"#a9a8a8",height:"22px", width:"22px"  }}
                    onClick={() => handleIncreaseYearMon(yearMonRef.current.props.value)}
                    ><i className="ri-arrow-right-s-line"></i></Button>
            </>
            }
        </div>
    );
};

export default CpmCommYearMon;
